import { ViewRowModel } from '@examdojo/supabase';
import { QuestionStoreModel } from './models';

export function mapDerivativeQuestionsHttpModelToStoreModel(
  derivativeQuestionHttpModel: ViewRowModel<'derivative_questions'>,
): QuestionStoreModel {
  return {
    id: derivativeQuestionHttpModel.id!,
    question_number: derivativeQuestionHttpModel.question_number!,
    authorId: derivativeQuestionHttpModel.author,
    items: (derivativeQuestionHttpModel.items ?? []) as QuestionStoreModel['items'],
    llm_feedback: derivativeQuestionHttpModel.llm_feedback as unknown as QuestionStoreModel['llm_feedback'],
    question_items: derivativeQuestionHttpModel.question_items as unknown as QuestionStoreModel['question_items'],
    metadata: derivativeQuestionHttpModel.metadata as QuestionStoreModel['metadata'],
    created_at: derivativeQuestionHttpModel.created_at!,
    status: derivativeQuestionHttpModel.status!,
    updated_at: derivativeQuestionHttpModel.updated_at!,
    updated_by: derivativeQuestionHttpModel.updated_by,
    reference_question_id: derivativeQuestionHttpModel.reference_question_id!,
    difficulty: derivativeQuestionHttpModel.difficulty as QuestionStoreModel['difficulty'],
  };
}
